import React, {useEffect, useState} from 'react';

const Accordion = (props) => {

    const [isOpen, setOpen] = useState(props.opened);

    useEffect(() => {
        setOpen(props.opened)
    }, [props.opened]);


    return (
        <div
            className={`accordion-item ${isOpen && 'accordion-item--opened'}`}>

            <div className={'accordion-item__line'}>
                {props.header(() => setOpen(!isOpen))}
                <span className={'accordion-item__icon'} onClick={() => setOpen(!isOpen)}/>
            </div>
            <div className={'accordion-item__inner'}>
                <div className={'accordion-item__content'}>
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export default Accordion;
